import React from 'react';
import SIAProjectFull from './Full';

import { SimpleTeaser } from '../../../components';

const SIAProject = (props) => {
  const { viewMode } = props;
  switch (viewMode) {
    case 'teaser':
      return <SimpleTeaser withSummary {...props} />;

    default:
      return <SIAProjectFull {...props} />;
  }
};

export default SIAProject;
